<h2 *ngIf="data?.title" mat-dialog-title>{{ data.title }}</h2>
<h2 *ngIf="!data?.title" mat-dialog-title i18n>Please wait...</h2>
<div mat-dialog-content>
  <mat-progress-bar mode="indeterminate"></mat-progress-bar>
</div>
